import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class X49MK2Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;




        let image = (
            <TransomConfigurator colorMultiplier={1.0} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    .02861, 0.021494, 0, 0.000028,
                    0.00682, 0.08485, 0, 0.000044,
                    0, 0, 1, 0,
                    155, 301, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='X49 Summary Text' /></p>

                    <PdfForm boat="x49mk2" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />


                    <ShareFrom configuration={this.props.configuration} boat="x49mk2" code={this.props.code} />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2Summary);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-Summary.js